export default class DocumentExistsException extends Error {
  constructor(message, identifier) {
    super(message);
    this.identifier = identifier;
  }
}
